<div class="n-tela-cadastro">
  <div class="n-container">
    <!-- Conteúdo principal em duas colunas -->
    <div class="n-tela-cadastro-content">
      <!-- Coluna esquerda - Informações -->
      <div class="n-tela-cadastro-info">
        <!-- Logo e botão de boas-vindas -->
        <div class="n-header-info">
          <img
            class="n-logo n-logo-clickable"
            src="assets/icons/nomoh_logo.svg"
            alt="Nomoh Logo"
            (click)="navegarHome()"
            role="link"
            tabindex="0"
            (keydown.enter)="navegarHome()"
          />
          <button class="n-welcome-btn" disabled>
            <i class="pi pi-user"></i>
            {{ 'PAGINA_EDITAR.EDITAR_PERFIL' | translate }}
          </button>
        </div>

        <!-- Título principal -->
        <div class="n-title-section">
          <h1 class="n-main-title">
            {{ 'PAGINA_EDITAR.ATUALIZE_SUAS' | translate }}
            <strong>{{
              'PAGINA_EDITAR.INFORMACOES_PESSOAIS' | translate
            }}</strong>
            {{ 'PAGINA_EDITAR.E_MANTENHA' | translate }}
          </h1>
          <p class="n-main-subtitle">
            {{ 'PAGINA_EDITAR.MANTENHA_DADOS' | translate }}
          </p>
        </div>

        <!-- Lista de benefícios -->
        <div class="n-benefits-list">
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>{{ 'PAGINA_EDITAR.DADOS_PESSOAIS' | translate }}</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>{{ 'PAGINA_EDITAR.INFOMACOES_CONTATO' | translate }}</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>{{ 'PAGINA_EDITAR.ENDERECO_ATUALIZADO' | translate }}</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>{{ 'PAGINA_EDITAR.FOTO_PERFIL' | translate }}</span>
          </div>
        </div>
      </div>

      <!-- Coluna direita - Formulário -->
      <div class="n-tela-cadastro-form">
        <div class="n-form-card">
          <!-- Header do formulário -->
          <div class="n-form-header">
            <!-- <h2 class="n-form-title">{{ "PAGINA_EDITAR.TITULO" | translate }}</h2> -->
            <p class="n-form-subtitle">
              {{ 'PAGINA_EDITAR.ATUALIZE_SEUS_DADOS' | translate }}
            </p>
          </div>

          @if ($carregandoDados()) {
          <div class="n-form-skeleton" aria-busy="true" aria-live="polite">
            <div class="n-skeleton-upload">
              <p-skeleton shape="circle" size="5.5rem"></p-skeleton>
              <p-skeleton width="10rem" height="2.25rem" borderRadius="999px"></p-skeleton>
            </div>

            <div class="n-skeleton-section">
              <p-skeleton width="40%" height="1.25rem" styleClass="mb-3"></p-skeleton>
              <p-skeleton width="100%" height="2.75rem" styleClass="mb-3"></p-skeleton>
              <div class="n-skeleton-row">
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
              </div>
              <p-skeleton width="100%" height="2.75rem" styleClass="mb-3"></p-skeleton>
              <p-skeleton width="48%" height="2.75rem"></p-skeleton>
            </div>

            <div class="n-skeleton-section">
              <p-skeleton width="30%" height="1.25rem" styleClass="mb-3"></p-skeleton>
              <div class="n-skeleton-row">
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
              </div>
              <div class="n-skeleton-row">
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
              </div>
              <div class="n-skeleton-row">
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
              </div>
              <div class="n-skeleton-row">
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
                <p-skeleton width="100%" height="2.75rem"></p-skeleton>
              </div>
            </div>

            <div class="n-skeleton-actions">
              <p-skeleton width="7rem" height="2.5rem" borderRadius="999px"></p-skeleton>
              <p-skeleton width="7rem" height="2.5rem" borderRadius="999px"></p-skeleton>
            </div>
          </div>
          } @else {
          <form [formGroup]="form" (ngSubmit)="salvar()" class="n-form-grid">
            <!-- Upload de Foto de Perfil -->
            <div class="n-form-section">
              <div class="n-upload-container">
                <div class="n-avatar-wrapper">
                  <div class="n-avatar" [class.n-has-image]="filePreviewUrl">
                    <img
                      *ngIf="filePreviewUrl; else avatarPlaceholder"
                      [src]="filePreviewUrl"
                      alt="Preview da foto"
                      class="n-avatar-image"
                    />
                    <ng-template #avatarPlaceholder>
                      <i class="pi pi-user n-avatar-icon"></i>
                    </ng-template>
                  </div>

                  <div class="n-upload-actions">
                    <input
                      #fileInputImagem
                      type="file"
                      accept="image/*"
                      class="n-file-input-hidden"
                      (change)="onImagemSelecionada($event)"
                    />

                    <button
                      type="button"
                      pButton
                      icon="pi pi-camera"
                      [label]="placeHolderBotaoImagem"
                      class="n-upload-trigger"
                      (click)="selecionarImagem()"
                    ></button>

                    <button
                      *ngIf="filePreviewUrl"
                      type="button"
                      pButton
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-sm p-button-danger n-remove-btn"
                      (click)="removerImagem()"
                    >
                      <span class="sr-only">Remover imagem</span>
                    </button>
                  </div>
                </div>
                @if ($erroImagem()) {
                <small class="n-upload-error" role="alert">{{
                  $erroImagem()
                }}</small>
                }
                <small class="n-upload-hint">{{
                  'PAGINA_EDITAR.ADCIONAR_FOTO' | translate
                }}</small>
              </div>
            </div>

            <!-- Dados Pessoais -->
            <div class="n-form-section">
              <h3 class="n-section-title">
                <i class="pi pi-user"></i>
                {{ 'PAGINA_EDITAR.TITULO_DADOS_PESSOAIS' | translate }}
              </h3>

              <div class="n-field-group">
                <div class="n-field n-field-full">
                  <lib-form-field
                    label="{{ 'GLOBAL.NOME_COMPLETO' | translate }}"
                    controlName="nome"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="nome"
                      [placeholder]="placeholderNomeCompleto"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>

                <div class="n-field n-field-full">
                  <lib-form-field
                    label="{{ 'GLOBAL.PAIS' | translate }}"
                    controlName="endereco.pais"
                    [required]="true"
                  >
                    @if (isMobileView()) {
                    <lib-n-multiselect
                      [multiple]="false"
                      [formControl]="paisControl"
                      [options]="paises"
                      optionLabel="nome"
                      optionValue="codigo"
                      placeholder="Selecione o país"
                    />
                    } @else {
                    <p-select
                      [formControl]="paisControl"
                      [options]="paises"
                      optionLabel="nome"
                      optionValue="codigo"
                      placeholder="Selecione o país"
                      [filter]="true"
                      filterBy="nome"
                      emptyMessage="Nenhum país encontrado"
                      emptyFilterMessage="Nenhum país encontrado"
                      [appendTo]="dropdownAppendTo"
                      styleClass="w-full"
                    />
                    }
                  </lib-form-field>
                </div>

                <div class="n-field n-field-full">
                  <lib-form-field
                    label="{{ 'GLOBAL.TELEFONE' | translate }}"
                    controlName="telefone"
                    [required]="true"
                  >
                    <lib-phone-input
                      [value]="form.get('telefone')?.value ?? ''"
                      (valueChange)="onTelefoneChange($event)"
                    />
                  </lib-form-field>
                </div>

                <div class="n-field n-field-full">
                  <lib-form-field
                    label="{{ 'GLOBAL.EMAIL' | translate }}"
                    controlName="email"
                    [required]="true"
                    [helpText]="$emailSomenteLeitura() ? ('PAGINA_EDITAR.EMAIL_OAUTH_SOMENTE_LEITURA' | translate) : ''"
                  >
                    <input
                      pInputText
                      formControlName="email"
                      type="email"
                      [placeholder]="placeholderEmail"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>

                @if ($exibirCpf()) {
                <div class="n-field n-field-large">
                  <lib-form-field
                    label="{{ 'GLOBAL.CPF_CNPJ' | translate }}"
                    controlName="cpfCnpj"
                  >
                    <input
                      pInputText
                      formControlName="cpfCnpj"
                      (input)="formatarCpfCnpj($event)"
                      placeholder="000.000.000-00"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
                }

                <div class="n-field n-field-large">
                  <lib-form-field
                    label="{{ 'GLOBAL.SEXO' | translate }}"
                    controlName="sexo"
                  >
                    @if (isMobileView()) {
                    <lib-n-multiselect
                      [multiple]="false"
                      formControlName="sexo"
                      [options]="sexoOpcoes"
                      optionLabel="label"
                      optionValue="value"
                      [placeholder]="'GLOBAL.SELECIONE_SEXO' | translate"
                    />
                    } @else {
                    <p-select
                      [options]="sexoOpcoes"
                      formControlName="sexo"
                      optionLabel="label"
                      optionValue="value"
                      [placeholder]="'GLOBAL.SELECIONE_SEXO' | translate"
                      [styleClass]="'w-full'"
                    />
                    }
                  </lib-form-field>
                </div>
              </div>
            </div>
            <!-- Endereço -->
            <div class="n-form-section" formGroupName="endereco">
              <h3 class="n-section-title">
                <i class="pi pi-home"></i>
                {{ 'PAGINA_EDITAR.TITULO_ENDERECO' | translate }}
              </h3>

              @if ($enderecoBrasil()) {
              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-4 n-cep-section">
                  <div class="n-field">
                    <lib-form-field
                      label="{{ 'GLOBAL.CEP' | translate }}"
                      controlName="codPostal"
                      [required]="true"
                      helpText="Preenchimento automático"
                    >
                      <p-inputMask
                        formControlName="codPostal"
                        mask="99999-999"
                        placeholder="00000-000"
                        (onBlur)="buscarCep($event)"
                        autocomplete="off"
                      ></p-inputMask>
                    </lib-form-field>
                  </div>
                </div>
                <div class="w-full md:w-8 n-field">
                  <lib-form-field
                    label="{{ 'GLOBAL.LOGRADOURO' | translate }}"
                    controlName="logradouro"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="logradouro"
                      [placeholder]="placeholderLogradouro"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
              </div>

              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-3 n-field">
                  <lib-form-field
                    label="{{ 'GLOBAL.NUMERO' | translate }}"
                    controlName="numero"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="numero"
                      placeholder="123"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>

                <div class="w-full md:w-9 n-field">
                  <lib-form-field
                    label="{{ 'GLOBAL.COMPLEMENTO' | translate }}"
                    controlName="complemento"
                  >
                    <input
                      pInputText
                      formControlName="complemento"
                      [placeholder]="placeholderComplemento"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
              </div>

              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-6 n-field">
                  <lib-form-field
                    label="{{ 'GLOBAL.BAIRRO' | translate }}"
                    controlName="bairro"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="bairro"
                      [placeholder]="placeholderBairro"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>

                <div class="w-full md:w-6 n-field">
                  <lib-form-field
                    label="{{ 'GLOBAL.CIDADE' | translate }}"
                    controlName="cidade"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="cidade"
                      [placeholder]="placeholderCidade"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
              </div>

              <div class="flex flex-column md:flex-row w-full gap-3">
                <div class="w-full md:w-6 n-field">
                  <lib-form-field
                    label="{{ 'GLOBAL.ESTADO' | translate }}"
                    controlName="estado"
                    [required]="true"
                  >
                    @if (isMobileView()) {
                    <lib-n-multiselect
                      [multiple]="false"
                      formControlName="estado"
                      id="estado"
                      [options]="estados"
                      [placeholder]="placeholderEstado"
                    />
                    } @else {
                    <p-select
                      [options]="estados"
                      formControlName="estado"
                      [placeholder]="placeholderEstado"
                      id="estado"
                      [styleClass]="'w-full'"
                    />
                    }
                  </lib-form-field>
                </div>
              </div>
              } @else {
              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-8 n-field">
                  <lib-form-field
                    label="AddressLine"
                    controlName="logradouro"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="logradouro"
                      placeholder="Street, avenue"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
                <div class="w-full md:w-4 n-field">
                  <lib-form-field
                    label="AddressNumber"
                    controlName="numero"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="numero"
                      placeholder="12"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
              </div>

              <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
                <div class="w-full md:w-6 n-field">
                  <lib-form-field label="City" controlName="cidade" [required]="true">
                    <input
                      pInputText
                      formControlName="cidade"
                      placeholder="City"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
                <div class="w-full md:w-6 n-field">
                  <lib-form-field
                    label="Region/administrativeArea"
                    controlName="estado"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="estado"
                      placeholder="Region"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
              </div>

              <div class="flex flex-column md:flex-row w-full gap-3">
                <div class="w-full md:w-6 n-field">
                  <lib-form-field
                    label="PostalCode"
                    controlName="codPostal"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="codPostal"
                      placeholder="Postal code"
                      maxlength="20"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
              </div>
              }
            </div>

            <!-- Botões de Ação -->
            <div class="n-form-actions">
              <p-button
                (onClick)="cancelar()"
                [disabled]="isLoading()"
                severity="secondary"
                styleClass="n-button-sec"
                type="button"
              >
                {{ 'GLOBAL.CANCELAR' | translate }}
              </p-button>

              <p-button
                [loading]="isLoading()"
                styleClass="n-button-prim"
                type="submit"
              >
                {{ 'GLOBAL.SALVAR' | translate }}
              </p-button>
            </div>
          </form>
          }
        </div>
      </div>
    </div>
  </div>
</div>
